export default __webpack_public_path__ + "static/media/home_product_img3_Hk.ed300333.webp";